// Dreamlink Studio hub — studio.dreamlink.global/
// Light cream editorial. Two offerings: Clipping and Localization.
// Copy voice: no em-dashes, "AI" is not used as a buzzword.

import { Link } from 'react-router-dom';
import { PublicNav } from '../../components/nav/PublicNav';
import { Pegasus } from '../../components/DreamlinkMark';

const MAROON = '#590b11';
const CREAM = '#F5F2EE';
const INK = '#262626';
const BROWN = '#6F5C53';
const LINE = 'rgba(38,38,38,0.12)';
const SERIF = "'Cormorant Garamond', Georgia, serif";

const OFFERINGS = [
  {
    to: '/clipping',
    kicker: '01 · Clipping',
    title: 'Clipping',
    body: 'Creators cut your content into short form and post it to their own audiences. Every clip is tracked across platforms, and you pay per verified view, not a flat fee.',
    points: ['Per-view payouts, verified hourly', 'A creator network at scale', 'One brief, many platforms'],
    cta: 'Run a clipping campaign',
  },
  {
    to: '/localization',
    kicker: '02 · Localization',
    title: 'Localization',
    body: 'Your content, in every language your audience speaks. We localize the videos you already own, distribute them across platforms and markets, then use the results to decide what to localize next.',
    points: ['Voice-matched dubbing and subtitles', 'Regional channels and audio tracks', 'Per-market analytics'],
    cta: 'Localize your library',
  },
];

export function Hub() {
  return (
    <div style={{ background: CREAM, color: INK, minHeight: '100vh', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}>
      <PublicNav theme="blue" />

      {/* Hero */}
      <header style={{ maxWidth: 980, margin: '0 auto', padding: '140px 28px 64px', textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color: MAROON, marginBottom: 22 }}>
          <Pegasus size={28} color={MAROON} />
        </div>
        <div style={{ fontSize: 12, letterSpacing: '0.32em', textTransform: 'uppercase', color: BROWN, marginBottom: 18 }}>
          Dreamlink Studio
        </div>
        <h1 style={{ fontFamily: SERIF, fontWeight: 300, fontSize: 'clamp(40px, 6vw, 72px)', lineHeight: 1.04, letterSpacing: '-0.01em', margin: 0 }}>
          The distribution arm of <span style={{ fontStyle: 'italic', color: MAROON }}>Dreamlink Global</span>.
        </h1>
        <p style={{ fontSize: 19, color: '#4D3C3A', maxWidth: 620, margin: '24px auto 0', lineHeight: 1.6 }}>
          One studio, two ways to put content in front of the audiences that matter: short-form clipping at scale, and full localization into every market your work can travel to.
        </p>
      </header>

      {/* Offerings */}
      <section style={{ maxWidth: 1040, margin: '0 auto', padding: '0 28px 96px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 24 }}>
        {OFFERINGS.map((o) => (
          <Link
            key={o.to}
            to={o.to}
            style={{
              display: 'block',
              background: '#FFFFFF',
              border: `0.5px solid ${LINE}`,
              padding: '40px 36px',
              color: INK,
              boxShadow: '0 14px 36px rgba(38,38,38,0.05)',
              transition: 'transform 240ms ease, box-shadow 240ms ease',
            }}
          >
            <div style={{ fontSize: 12, letterSpacing: '0.18em', textTransform: 'uppercase', color: BROWN, marginBottom: 16 }}>
              {o.kicker}
            </div>
            <h2 style={{ fontFamily: SERIF, fontWeight: 400, fontSize: 38, margin: '0 0 14px', color: MAROON }}>
              {o.title}
            </h2>
            <p style={{ fontSize: 15.5, color: '#4D3C3A', lineHeight: 1.65, margin: '0 0 20px' }}>{o.body}</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 26px' }}>
              {o.points.map((p) => (
                <li key={p} style={{ position: 'relative', padding: '8px 0 8px 22px', borderBottom: `0.5px solid ${LINE}`, fontSize: 14.5, color: INK }}>
                  <span style={{ position: 'absolute', left: 0, top: 14, width: 7, height: 7, border: `1px solid ${MAROON}`, transform: 'rotate(45deg)' }} />
                  {p}
                </li>
              ))}
            </ul>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13, letterSpacing: '0.06em', color: MAROON, fontWeight: 500 }}>
              {o.cta} <span aria-hidden>{'→'}</span>
            </span>
          </Link>
        ))}
      </section>

      {/* Foot */}
      <footer style={{ borderTop: `0.5px solid ${LINE}`, padding: '36px 28px', textAlign: 'center', color: BROWN, fontSize: 13 }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 8, color: MAROON }}>
          <Pegasus size={16} color={MAROON} />
          <span style={{ fontFamily: SERIF, letterSpacing: '0.14em', textTransform: 'uppercase', fontSize: 14 }}>Dreamlink Studio</span>
        </div>
        <div>studio.dreamlink.global · A Dreamlink Global company</div>
      </footer>
    </div>
  );
}
